<script setup>

</script>

<template>
    <div class="text-sm opacity-65 border flex gap-4 shadow-sm rounded-2xl bg-white dark:bg-black dark:border-neutral-700 p-4">
        <i class="pi pi-info-circle"></i>
        <p><slot></slot></p>
    </div>
</template>

<style scoped lang="scss">

</style>
